<template>
  <div class="home-page page-main">
    <template v-if="[1, 2].indexOf($store.getters.roles) > -1">
      <div class="home-title-box spaceLeft">
        <div class="home-title">
          <span>Home Page</span>
        </div>
      </div>
      <homeTopAuditor />
    </template>

    <template v-else>
      <div class="home-title-box spaceLeft">
        <div class="home-title">
          <!-- <span v-if="$store.getters.userInfo.companyName">
            Hi, {{ $store.getters.userInfo.companyName }}
          </span>
          <span v-else-if="$store.getters.metaMaskObj.account">
            Hi, <account :value="$store.getters.metaMaskObj.account" />
          </span> -->
          Hi, Welcome to the production portal!
        </div>
        <el-button
          round
          class="home-ver"
          size="small"
          :class="{ 'is-active': userStatus != 0 }"
          :disabled="userStatus != 0"
          @click="toAuthPage"
        >Verification</el-button>
        <!-- 因数字矿产未开发，暂时隐藏 -->
        <!-- <el-popover
          placement="bottom"
          trigger="hover"
          :disabled="$store.getters.userInfo.status==0"
        >
          <div v-if="$store.getters.userInfo">
            <div v-if="$store.getters.userInfo.kybdata" class="spaceLeft ver-item">
              <authStatus :status="2" v-if="$store.getters.userInfo.kyb"/>
              <authStatus :status="3" v-else/>
              <span class="ml">Business Verification</span>
            </div>
            <div v-if="$store.getters.userInfo.kycdata" class="spaceLeft ver-item">
              <authStatus :status="2" v-if="$store.getters.userInfo.kyc"/>
              <authStatus :status="3" v-else/>
              <span class="ml">Personal Verification</span>
            </div>
            <div class="spaceLeft ver-item" v-if="$store.getters.userInfo.status!=0">
              <authStatus :status="$store.getters.userInfo.status"></authStatus>
              <span class="ml">Mineral</span>
            </div>
            <div class="spaceLeft ver-item" v-if="$store.getters.userInfo.statusBtc!=0">
              <authStatus :status="$store.getters.userInfo.statusBtc"></authStatus>
              <span class="ml">BTC</span>
            </div>
            <div class="spaceLeft ver-item" v-if="$store.getters.userInfo.statusEth!=0">
              <authStatus :status="$store.getters.userInfo.statusEth"></authStatus>
              <span class="ml">ETH</span>
            </div>
          </div>
          <el-button
            @click="toAuthPage"
            slot="reference"
            class="home-ver"
            :class="{'is-active':$store.getters.userInfo.status!=0}"
          >
            Verification
            <img
              v-if="
                $store.getters.userInfo.status==3||$store.getters.userInfo.statusBtc==3||$store.getters.userInfo.statusEth==3
              "
              class="home-ver-warn"
              src="@/assets/image/home/warn.png"
            />
          </el-button>
        </el-popover> -->

        <el-popover placement="bottom" trigger="hover" :disabled="!$store.getters.annualInfo.isAnnualNav">
          <div style="word-break: break-word; font-size: 0.18rem">
            <div v-if="$store.getters.annualInfo.isExpired">
              Please submit an application for annual review！
            </div>
            <div v-if="$store.getters.annualInfo.isReject">Application rejected！</div>
          </div>
          <span
            v-if="$store.getters.annualInfo.isAnnualNav"
            slot="reference"
            class="home-ver"
            :class="annualClassName"
            @click="toAnnualPage"
          >
            Annual Review
            <img class="home-ver-warn" src="@/assets/image/home/warn.png">
          </span>
        </el-popover>
      </div>
      <homeTop />
    </template>
  </div>
</template>

<script>
import homeTop from './home/homeTop'
import homeTopAuditor from './home/homeTopAuditor'
import { getInfo } from '@/api/login.js'
export default {
  name: 'Index',
  components: {
    homeTop,
    homeTopAuditor
  },
  data() {
    return {
      userStatus: undefined
    }
  },
  computed: {
    annualClassName() {
      return 'is-active'
    }
  },
  async created() {
    const res = await getInfo()
    this.userStatus = res.result.status
    if (res.result.status === 0) {
      this.toAuthPage()
    }
    this.$store.dispatch('GetMessageUnRead')
  },
  methods: {
    toAuthPage() {
      this.$router.push('/authentication/index')
    },
    toAnnualPage() {
      this.$router.push('/wellManagement/annualReview')
    }
  }
}
</script>

<style lang="scss" scoped>
.home-title-box {
  margin-bottom: 0.24rem;

  .home-title {
    font-size: 0.26rem;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 0.2rem;
  }
}

.home-ver {
  background: #d9dde3;
  border-radius: 0.15rem;
  color: #fff;
  padding: 0.05rem 0.1rem;
  font-size: 0.16rem;
  font-weight: normal;
  margin-right: 0.16rem;
  position: relative;
  line-height: 0.2rem;
  cursor: pointer;
  border: 0;

  &.is-active {
    background: linear-gradient(99deg, #d3c2ef 0%, #7d98f7 48%, #a5c7ea 100%);
  }

  &.is-faild {
    background: #d9dde3;
  }

  .home-ver-warn {
    position: absolute;
    right: -0.1rem;
    top: -0.05rem;
    width: 0.2rem;
  }
}

.ver-item {
  margin: 0.08rem 0;
  font-size: 0.18rem;

  .ml {
    margin-left: 0.08rem;
  }
}
</style>
